exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-info-js": () => import("./../../../src/pages/info.js" /* webpackChunkName: "component---src-pages-info-js" */),
  "component---src-pages-showreels-js": () => import("./../../../src/pages/showreels.js" /* webpackChunkName: "component---src-pages-showreels-js" */),
  "component---src-pages-snaps-js": () => import("./../../../src/pages/snaps.js" /* webpackChunkName: "component---src-pages-snaps-js" */)
}

